<script>
import options from './CheckoutStepThree.options'
export default options
</script>

<template>
  <article class="kb-checkout-step-three kb-forms">

    <section class="kb-checkout-step-three__info-wrapper">
      <div class="kb-checkout-step-three__info-left">
        <h4 class="kb-checkout-step-three__info-title"
          :class="{ 'kb-checkout-step-three__info-title--hide': noDeliveryTitle }">{{ getLabel('informationTitle') }}
        </h4>
        <h4 class="kb-checkout-step-three__info-title"
          :class="{ 'kb-checkout-step-three__info-title--hide': !noDeliveryTitle }">
          {{ getLabel('informationAndDeliveryTitle') }}</h4>

        <template v-if="purchaseData.invoice.userInformation.customerType === 'company'">
          <div class="kb-checkout-step-three__margin-bottom">
            <!-- show company inputs if filled -->
            <template v-if="purchaseData.invoice.company.companyName">
              <p class="kb-checkout-step-three__text">{{ purchaseData.invoice.company.companyName }}</p>
            </template>
            <template v-if="purchaseData.invoice.company.companyDepartment">
              <p class="kb-checkout-step-three__text">{{ purchaseData.invoice.company.companyDepartment }}</p>
            </template>
            <template v-if="purchaseData.invoice.company.companyCvr">
              <p class="kb-checkout-step-three__text">{{ purchaseData.invoice.company.companyCvr }}</p>
            </template>
          </div>
        </template>

        <template v-if="purchaseData.invoice.userInformation.customerType === 'publicInstitution'">
          <div class="kb-checkout-step-three__margin-bottom">
            <!-- show public institution inputs if filled -->
            <template v-if="purchaseData.invoice.public.publicInstitutionNameInput">
              <p class="kb-checkout-step-three__text">{{ purchaseData.invoice.public.publicInstitutionNameInput }}</p>
            </template>
            <template v-if="purchaseData.invoice.public.publicInstitutionUserId">
              <p class="kb-checkout-step-three__text">{{ purchaseData.invoice.public.publicInstitutionUserId }}</p>
            </template>
            <template v-if="purchaseData.invoice.public.publicInstitutionDepartmentOrContact">
              <p class="kb-checkout-step-three__text">{{
            purchaseData.invoice.public.publicInstitutionDepartmentOrContact }}</p>
            </template>
            <template v-if="purchaseData.invoice.public.publicInstitutionEan">
              <p class="kb-checkout-step-three__text">{{ purchaseData.invoice.public.publicInstitutionEan }}</p>
            </template>
          </div>
        </template>

        <p class="kb-checkout-step-three__text kb-checkout-step-three__text-navn">
          {{ `${purchaseData.invoice.userInformation.contactFirstName}
          ${purchaseData.invoice.userInformation.contactLastName}`
          }}</p>
        <p class="kb-checkout-step-three__text">{{ purchaseData.invoice.invoiceAddress.addressLine }}</p>
        <p class="kb-checkout-step-three__text">{{ `${purchaseData.invoice.invoiceAddress.postalCode}
          ${purchaseData.invoice.invoiceAddress.city}` }}</p>
        <p class="kb-checkout-step-three__text kb-checkout-step-three__margin-top">{{ `
          ${purchaseData.invoice.userInformation.mobilePhone}` }}</p>
        <p class="kb-checkout-step-three__text">{{ purchaseData.invoice.userInformation.email }}</p>
        <button @click="handleSendToStep(1)" class="kb-checkout-step-three__link">{{ getLabel('informationEditTitle')
          }}</button>
      </div>

      <template v-if="!noDeliveryTitle">
        <div class="kb-checkout-step-three__info-right">
          <h4 class="kb-checkout-step-three__info-title">{{ getLabel('deliveryTitle') }}</h4>

          <template
            v-if="purchaseData.delivery.deliveryAddress.deliveryName || purchaseData.delivery.deliveryAddress.deliveryDepartment">
            <div class="kb-checkout-step-three__margin-bottom">
              <!-- show company inputs if filled -->
              <template v-if="purchaseData.delivery.deliveryAddress.deliveryName">
                <p class="kb-checkout-step-three__text">{{ purchaseData.delivery.deliveryAddress.deliveryName }}</p>
              </template>
              <template v-if="purchaseData.delivery.deliveryAddress.deliveryDepartment">
                <p class="kb-checkout-step-three__text">{{ purchaseData.delivery.deliveryAddress.deliveryDepartment }}
                </p>
              </template>
            </div>
          </template>

          <template v-if="purchaseData.delivery.deliveryAddress.name">
            <p class="kb-checkout-step-three__text kb-checkout-step-three__text-navn">{{
            purchaseData.delivery.deliveryAddress.name }}</p>
          </template>

          <template v-if="purchaseData.delivery.deliveryAddress.contactFirstName">
            <p class="kb-checkout-step-three__text kb-checkout-step-three__text-navn">{{
            `${purchaseData.delivery.deliveryAddress.contactFirstName}
              ${purchaseData.delivery.deliveryAddress.contactLastName}` }}</p>
          </template>

          <p class="kb-checkout-step-three__text">{{ purchaseData.delivery.deliveryAddress.addressLine }}</p>
          <p class="kb-checkout-step-three__text">{{ `${purchaseData.delivery.deliveryAddress.postalCode}
            ${purchaseData.delivery.deliveryAddress.city}` }}</p>
          <a @click="handleSendToStep(2)" class="kb-checkout-step-three__link">{{ getLabel('deliveryEditTitle') }}</a>
        </div>
      </template>

    </section>

    <template v-if="displayUdlaansvarePickupMessage">
      <div class="kb-frivillige-checkout-content__message">
        <p>{{ getLabelCheckoutNavigation('udlaanDeliveryText') }}</p>
      </div>        
    </template>

    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 704 1">
      <path fill="#DFDFDB" d="M0 0h704v1H0z" />
    </svg>

    <!-- WX06 - WebshopPaymentMethod -->
    <template v-if="showPaymentOptions">
      <WebshopPaymentSelector />
    </template>


    <!-- Terms & conditions checkbox -->
    <div class="kb-checkout-step-three__terms-wrapper FormTextbox" aria-live="assertive" :class="{ 'validation-error': !termsInputFilled }">
      <div class="kb-checkout-step-three__terms-wrapper-inputs">
        <input v-model="termsInput" type="checkbox" id="terms" name="" value="termsChoice">
        <label for="terms">
          {{ getLabel('termsAndConditionsText') }}
          <span class="kb-checkout-step-three__link">
            <a :href="getLabel('termsAndConditionsLink')" target="_blank"> {{ getLabel('termsAndConditionsTextLink')
              }}</a>
          </span>
        </label>
      </div>
      <p class="Form__Element__ValidationError" role="alert" v-if="!unSubmitted && !termsInputFilled && !hideAllErrors">
        {{ getLabel('termsAndConditionsErrorMessage') }}
      </p>
    </div>

    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 704 1">
      <path fill="#DFDFDB" d="M0 0h704v1H0z" />
    </svg>


    <!-- Reusing styles from stepOneNavigation to have styles in one place -->
    <div class="kb-checkout-step-three__navigation">
      <div class="kb-checkout-step-three__navigation-button-wrapper">
        <button @click="toStepTwo" class="kb-button">{{ getLabelCheckoutNavigation('backButtonTextStep3') }}</button>
        <button @click="onSubmit"
                  :disabled="isSubmitting || isStepSubmitting"
          class="kb-checkout-step-three__bottom-button submit kb-button kb-button--full-color-spot">
          {{ getLabelCheckoutNavigation('submitButtonTextStep3') }}
        </button>
      </div>

      <p v-if="isSubmissionError" class="kb-forms Form__Element__ValidationError kb-sign-up-form__validation-error">
          {{ getLabelCheckoutNavigation('exceedMaxQuantityErrorMessage') }}
      </p>
    </div>

    <template v-if="isSubmitting">
      <div class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky">
        </div>
      </div>
    </template>

  </article>
</template>
